import type { JSX } from 'react'

export const QualityBadgeHdIcon = (): JSX.Element => (
  <use href='#qualityBadgeHdIcon' height='100%' width='100%' />
)
